import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fadeInRight400ms } from '@vex/animations/fade-in-right.animation';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from '@vex/animations/scale-fade-in.animation';
import { scaleIn400ms } from '@vex/animations/scale-in.animation';
import { stagger40ms } from '@vex/animations/stagger.animation';
import { ResizeHorizontalService } from '@vex/helper/resize-horizontal';
import { Icons } from '@vex/icons/icons';
import { AdvanceDataTypeService } from '@vex/services/advance-data-type.service';
import { HelperService } from '@vex/services/helper.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'vex-security-popup',
  templateUrl: './security-popup.component.html',
  styleUrls: ['./security-popup.component.scss'],
  animations: [scaleIn400ms, fadeInRight400ms, stagger40ms, fadeInUp400ms, scaleFadeIn400ms]
})
export class SecurityPopupComponent extends Icons implements OnInit,OnDestroy {

  isGetComplexAttribute: boolean = false;
  columns: any;
  data: any;
  name: any;
  displayName: any;
  applyResizeColumnsTableId: any[] = [];
  private destroy$ = new Subject<void>();


  constructor(@Inject(MAT_DIALOG_DATA) public datas: any,
  public dialogRef: MatDialogRef<SecurityPopupComponent>,
  private advanceDataTypeService: AdvanceDataTypeService,
  public helperService: HelperService,
  private resizeHorizontalService: ResizeHorizontalService,
  ) {
    super();
    this.columns = this.datas.columns;
    this.data = this.datas.data
    this.name = this.datas.name
    this.isGetComplexAttribute = this.datas.isGetComplexAttribute
    this.displayName = this.datas.displayName
   }

   scrollHeight:string = "";
  ngOnInit(): void {
    this.scrollHeight = this.getHeight(200);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getHeight(extra: number = 0) {
    let navHeight = 37;
    const height_inner = (window.innerHeight - navHeight - extra).toString();
    return height_inner + 'px';
  }

  resizeTables() {
    var tables = document.getElementsByClassName('resizableTable');
    for (var i = 0; i < tables.length; i++) {
      if (this.applyResizeColumnsTableId.findIndex((x) => x == tables[i].id && tables[i].id == (this.name + '_tables')) == -1) {
        this.applyResizeColumnsTableId.push(tables[i].id);
        this.resizeHorizontalService.resizableGrid(tables[i]);
      }
    }
    this.callUntilTableResizeAble();
  }

  callUntilTableResizeAble() {
    let scope = this;
    if (this.applyResizeColumnsTableId.findIndex((x) => x == this.name + '_tables') == -1) {
      setTimeout(() => {
        scope.resizeTables();
      }, 500);
    }
  }

  getRowAttribute(data) {
    if(this.isGetComplexAttribute) {
      return data._ComplexAttributes;
    }
    return this.columns;
  }

  getAttributeValue(data, attribute) {
    let value: any;
    if (data) {
      value = data[attribute.Name];
      if (data['ddLable_' + attribute.Name]) {
        value = data['ddLable_' + attribute.Name] || data[attribute.Name];
      }
      if(!attribute.AttributeType) {
        this.advanceDataTypeService.getAttributeDataTypeForValue(attribute, true);
      }
      if(!attribute.AttributeType) {
        return 'N/A';
      }
      if (attribute.AttributeType.BaseType == 'int' && value == 0) {
        return '0';
      }
      if (attribute.AttributeType.BaseType == 'bool' && value == false) {
        return 'false';
      }
      if (attribute.AttributeType.Name?.toLowerCase() == 'password' && value) {
        return '******';
      }
      if (attribute.DisplayType == 2) {
        if(attribute.IsVisible) {
          let values = [];
          if (data[attribute.Name + '_data']) {
            let val = data[attribute.Name + '_data'];
            val = JSON.parse(val);
            let keys = Object.keys(val);
            keys.forEach((key) => {
              let options = val[key];
              values = [...values, ...options];
            });
          }
          if (attribute.IsList) {
            value = [];
            value = values.map((x) => {
              return x.Label;
            });
            if (value) {
              value = value.join(', ');
            }
          } else {
            value = values[0]?.Label || data[attribute.Name];
          }
        } else {
          return 'N/A';
        }
      }
    }

    return value ? value : 'N/A';
  }

  onClose() {
    this.helperService.onClose();
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    this.resizeTables();
  }

  trackByListId(index: number, list: any) {
    return list.Id || list.Name;
  }

}
